/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React from "react";

import { ProjectStatusBadge, Favorite, ProjectProgress } from "./components";

import { formatDate } from "../../../helpers/date";

const PROJECT_COLUMNS = [
  {
    Header: <Favorite value toggleable={false} />,
    headerClassName: "flex -center-h",
    accessor: "isFavorite",
    id: "favorites",
    Cell: ({ value, row }) => <Favorite value={value} row={row} />,
    sortable: false,
    minWidth: 50,
    maxWidth: 50
  },
  {
    Header: "Status",
    accessor: "status",
    id: "project_status.label",
    Cell: ProjectStatusBadge,
    minWidth: 140,
    maxWidth: 170
  },
  {
    Header: "Name",
    accessor: "name",
    id: "name"
  },
  {
    Header: "Customer",
    accessor: "customer",
    id: "customer.name"
  },
  {
    Header: "Call Type",
    accessor: "callType",
    id: "call_type.label",
    maxWidth: 160
  },
  {
    Header: "Department",
    accessor: "department",
    id: "department",
    maxWidth: 160,
    Cell: ({ row }) => row?.department || "--"
  },
  {
    Header: "Department Category",
    accessor: "department_category",
    id: "department_category",
    maxWidth: 160,
    Cell: ({ row }) => row?.department_category || "--"
  },
  {
    Header: "Project Manager",
    accessor: "projectManager",
    id: "project_manager.full_name",
    maxWidth: 160
  },
  {
    Header: "Start Date",
    accessor: "startDate",
    id: "start_date",
    maxWidth: 120,
    Cell: ({ value }) => (value ? formatDate(value, "MM/dd/yyyy") : "--")
  },
  {
    Header: "Actual Hours",
    headerClassName: "flex -center-h",
    accessor: "hoursConsumed",
    id: "hours_consumed",
    maxWidth: 100,
    minWidth: 100,
    Cell: ProjectProgress
  }
];

export default PROJECT_COLUMNS;
